module.exports = __webpack_public_path__ + "static/media/30.2ba5b0a8.jpg";